import { render, staticRenderFns } from "./PropertyRelated.vue?vue&type=template&id=76bb7c6d"
import script from "./PropertyRelated.vue?vue&type=script&lang=js"
export * from "./PropertyRelated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports